import React, { useState } from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon, MusicIcon, MapPinIcon, PhoneIcon, MailIcon, MessageCircleIcon, CalendarIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
export function Footer() {
  const [miniForm, setMiniForm] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: ''
  });
  const [miniStatus, setMiniStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const handleMiniChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMiniForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleMiniSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMiniStatus('sending');
    try {
      await emailjs.send('service_ld498wo', 'template_ysz3gxn', {
        from_name: miniForm.nombre,
        from_email: miniForm.email,
        phone: miniForm.telefono,
        salon_name: miniForm.empresa,
        message: `Contacto rápido desde footer:\n\nNombre: ${miniForm.nombre}\nEmail: ${miniForm.email}\nTeléfono: ${miniForm.telefono}\nEmpresa: ${miniForm.empresa}`
      }, '0SqCHVYKMPHE_MNQM');
      setMiniStatus('success');
      setMiniForm({
        nombre: '',
        email: '',
        telefono: '',
        empresa: ''
      });
      setTimeout(() => setMiniStatus('idle'), 4000);
    } catch {
      setMiniStatus('error');
    }
  };
  const miniInputClasses = 'bg-[#0a0a0a] border border-white/10 rounded-md px-3 py-2.5 text-white placeholder-gray-500 text-sm focus:outline-none focus:border-gold/50 transition-colors w-full';
  return <footer className="bg-surface pt-14 md:pt-20 pb-0" data-id="element-124">
      <div className="max-w-6xl mx-auto px-5 md:px-8" data-id="element-125">
        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 pb-12 md:pb-16" data-id="element-126">
          {/* Column 1: Brand */}
          <div className="lg:col-span-1" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/nZqkddm5E5UrbhfRn3ESPb/IMG_6635.jpg" alt="Doctor Ecommerce" className="h-10 w-auto mb-5" data-id="element-128" />
            <p className="text-gold italic font-semibold text-sm mb-4" data-id="element-129">
              La cura para negocios estancados.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-130">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex items-center gap-4" data-id="element-131">
              <a href="#" aria-label="Instagram" className="text-gray-400 hover:text-gold transition-colors" data-id="element-132">
                <InstagramIcon className="w-5 h-5" data-id="element-133" />
              </a>
              <a href="#" aria-label="Facebook" className="text-gray-400 hover:text-gold transition-colors" data-id="element-134">
                <FacebookIcon className="w-5 h-5" data-id="element-135" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-gray-400 hover:text-gold transition-colors" data-id="element-136">
                <LinkedinIcon className="w-5 h-5" data-id="element-137" />
              </a>
              <a href="#" aria-label="TikTok" className="text-gray-400 hover:text-gold transition-colors" data-id="element-138">
                <MusicIcon className="w-5 h-5" data-id="element-139" />
              </a>
            </div>
          </div>

          {/* Column 2: Servicios */}
          <div data-id="element-140">
            <h4 className="text-gold font-bold text-sm tracking-wider uppercase mb-5" data-id="element-141">
              Servicios
            </h4>
            <ul className="space-y-2.5 text-gray-400 text-sm" data-id="element-142">
              <li data-id="element-143">Meta Ads · Google Ads · TikTok Ads · YouTube Ads</li>
              <li data-id="element-144">Email · SMS · Retargeting Automatizado</li>
              <li data-id="element-145">Automatización con IA para Ventas 24/7</li>
              <li data-id="element-146">Funnels Quirúrgicos por Industria</li>
              <li data-id="element-147">Blindaje Digital &amp; Anti-Ban</li>
              <li data-id="element-148">PR Digital &amp; Posicionamiento en Medios</li>
              <li data-id="element-149">CRM &amp; Data Tracking Avanzado</li>
              <li data-id="element-150">Video Marketing IA · SEO · Branding</li>
              <li data-id="element-151">Gestión de Reputación · Google Maps</li>
              <li data-id="element-152">Diseño Web · Landing Pages · CRO</li>
            </ul>
          </div>

          {/* Column 3: Recursos */}
          <div data-id="element-153">
            <h4 className="text-gold font-bold text-sm tracking-wider uppercase mb-5" data-id="element-154">
              Recursos
            </h4>
            <ul className="space-y-2.5 text-gray-400 text-sm" data-id="element-155">
              <li data-id="element-156">Blog de Estrategia</li>
              <li data-id="element-157">Casos de Éxito</li>
              <li data-id="element-158">Política de Privacidad</li>
              <li data-id="element-159">Términos y Condiciones</li>
            </ul>
          </div>

          {/* Column 4: Contacto Directo */}
          <div data-id="element-160">
            <h4 className="text-gold font-bold text-sm tracking-wider uppercase mb-5" data-id="element-161">
              Contacto Directo
            </h4>
            <ul className="space-y-3 text-gray-300 text-sm mb-6" data-id="element-162">
              <li className="flex items-start gap-2.5" data-id="element-163">
                <MapPinIcon className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-164" />
                <span data-id="element-165">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-2.5" data-id="element-166">
                <PhoneIcon className="w-4 h-4 text-gold shrink-0" data-id="element-167" />
                <a href="tel:+14028720639" className="hover:text-gold transition-colors" data-id="element-168">
                  402-872-0639
                </a>
              </li>
              <li className="flex items-center gap-2.5" data-id="element-169">
                <MailIcon className="w-4 h-4 text-gold shrink-0" data-id="element-170" />
                <a href="mailto:doctor.ecommerceus@gmail.com" className="hover:text-gold transition-colors break-all" data-id="element-171">
                  doctor.ecommerceus@gmail.com
                </a>
              </li>
            </ul>
            <div className="space-y-3" data-id="element-172">
              <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-emerald hover:bg-emerald/90 text-white font-semibold py-3 px-4 rounded-lg text-sm transition-colors" data-id="element-173">
                <MessageCircleIcon className="w-4 h-4" data-id="element-174" />
                Habla con un Especialista
              </a>
              <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full border border-gold text-gold hover:bg-gold/10 font-semibold py-3 px-4 rounded-lg text-sm transition-colors" data-id="element-175">
                <CalendarIcon className="w-4 h-4" data-id="element-176" />
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 py-8 md:py-10" data-id="element-177">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-178">
            {/* Partners badges */}
            <div data-id="element-179">
              <p className="text-gray-500 text-[11px] font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-180">
                Partners Certificados y Tecnología de Élite
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-181">
                <span className="border border-white/10 rounded px-3 py-1.5 text-gray-500 text-xs" data-id="element-182">
                  Meta
                </span>
                <span className="border border-white/10 rounded px-3 py-1.5 text-gray-500 text-xs" data-id="element-183">
                  Google Ads
                </span>
                <span className="border border-white/10 rounded px-3 py-1.5 text-gray-500 text-xs" data-id="element-184">
                  Certified
                </span>
                <span className="border border-white/10 rounded px-3 py-1.5 text-gray-500 text-xs" data-id="element-185">
                  Shopify
                </span>
              </div>
            </div>

            {/* Mini contact form */}
            <div data-id="element-186">
              <p className="text-gray-500 text-[11px] font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-187">
                ¿Quieres que te contactemos?
              </p>
              <form onSubmit={handleMiniSubmit} className="flex flex-col sm:flex-row flex-wrap gap-2" data-id="element-188">
                <input type="text" name="nombre" placeholder="Tu Nombre" value={miniForm.nombre} onChange={handleMiniChange} required className={`${miniInputClasses} sm:flex-1 sm:min-w-[120px]`} data-id="element-189" />
                <input type="email" name="email" placeholder="Tu Email" value={miniForm.email} onChange={handleMiniChange} required className={`${miniInputClasses} sm:flex-1 sm:min-w-[120px]`} data-id="element-190" />
                <input type="tel" name="telefono" placeholder="Tu Teléfono" value={miniForm.telefono} onChange={handleMiniChange} className={`${miniInputClasses} sm:flex-1 sm:min-w-[120px]`} data-id="element-191" />
                <input type="text" name="empresa" placeholder="Nombre de tu Empresa" value={miniForm.empresa} onChange={handleMiniChange} className={`${miniInputClasses} sm:flex-1 sm:min-w-[120px]`} data-id="element-192" />
                <button type="submit" disabled={miniStatus === 'sending'} className="bg-gold text-carbon font-bold py-2.5 px-6 rounded-md text-sm hover:bg-gold/90 transition-colors disabled:opacity-60 cursor-pointer whitespace-nowrap" data-id="element-193">
                  {miniStatus === 'sending' ? '...' : miniStatus === 'success' ? '✓ ENVIADO' : 'ENVIAR'}
                </button>
              </form>
            </div>
          </div>

          {/* Copyright */}
          <p className="text-gray-600 text-xs text-center mt-8 pb-4" data-id="element-194">
            © {new Date().getFullYear()} Doctor Ecommerce. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}